import {useQuery} from '@tanstack/react-query'
import {MAIN_REJESTR_API_SHORT} from '../../../../components/utils/consts.js'
import {getData} from "../../../app/getters/getData.js";

export const useListaProfiliProjktu = (id, enabled = true) => {

    let endpoint = `/${MAIN_REJESTR_API_SHORT}/uzytkownicy/${id}`
    let queryKey = [`lista_profili_projektu`, id]

    return useQuery({
        queryKey,
        queryFn: () => getData(`${endpoint}`),
        enabled: enabled,
        refetchOnMount: true,
        refetchInterval: 1000 * 60 * 15,
    })
}
